import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ff1c72e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-details-network" }
const _hoisted_2 = { class: "columns is-multiline" }
const _hoisted_3 = { class: "column is-12-touch is-8-desktop is-8-widescreen" }
const _hoisted_4 = { class: "column is-12-touch is-4-desktop is-4-widescreen" }
const _hoisted_5 = { class: "device-section" }
const _hoisted_6 = { class: "has-text-weight-semibold" }
const _hoisted_7 = { class: "has-text-weight-semibold" }
const _hoisted_8 = { class: "has-text-weight-semibold" }
const _hoisted_9 = { class: "has-text-weight-semibold" }
const _hoisted_10 = { class: "has-text-weight-semibold" }
const _hoisted_11 = { class: "has-text-weight-semibold" }
const _hoisted_12 = { class: "has-text-weight-semibold" }
const _hoisted_13 = { class: "has-text-weight-semibold" }
const _hoisted_14 = { class: "has-text-weight-semibold" }
const _hoisted_15 = { class: "has-text-weight-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chart_network = _resolveComponent("chart-network")!
  const _component_n_descriptions_item = _resolveComponent("n-descriptions-item")!
  const _component_n_descriptions = _resolveComponent("n-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_chart_network, {
          class: "chart-network",
          station: _ctx.station,
          measures: _ctx.measures,
          since: _ctx.since,
          before: _ctx.before
        }, null, 8 /* PROPS */, ["station", "measures", "since", "before"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_n_descriptions, {
            hoverable: "",
            "label-placement": "left",
            title: _ctx.$t('device_details.network.network_configuration_title'),
            size: "large",
            column: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_descriptions_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('device_details.overview.network_type')), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.networkType || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              (_ctx.station?.type === 'avolta-lorawan')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 0 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('device_details.network.network_app_eui')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.appEUI || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.station?.type === 'avolta-lorawan')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 1 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('device_details.network.dev_eui_label')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.devEUI || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.station?.type === 'avolta-lorawan')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 2 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('device_details.network.app_key_label')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.appKey || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.station?.type === 'avolta-ltem')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 3 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('device_details.network.carrier_label')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.carrier || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.station?.type === 'avolta-ltem')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 4 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('device_details.network.protocol_label')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.protocol || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.station?.type === 'avolta-ltem')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 5 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('device_details.network.apn_label')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.apn || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.station?.type === 'avolta-ltem' && _ctx.station?.network?.protocol === 'MQTT')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 6 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('device_details.network.mqtt_host_label')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.MQTT_host || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.station?.type === 'avolta-ltem' && _ctx.station?.network?.protocol === 'MQTT')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 7 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('device_details.network.mqtt_client_id_label')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.MQTT_client_id || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.station?.type === 'avolta-ltem' && _ctx.station?.network?.protocol === 'MQTT')
                ? (_openBlock(), _createBlock(_component_n_descriptions_item, { key: 8 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('device_details.network.mqtt_client_secret_label')), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.MQTT_client_secret || '-'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"])
        ])
      ])
    ])
  ]))
}